/*START - Custom code*/
function checkCookie(name) {
  var matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
      name.replace(/([.$?*|{}()[]\\\/\+^])/g, "\\$1") +
      "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, value, days) {
  var expires = "";
  if (days) {
    var date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = name + "=" + (value || "") + expires + "; path=/";
}

// View tracking function
function trackItemView(fsId) {
  // Check if we're on a product page
  if (!fsId) return;

  // Get the last view timestamp for this product
  const lastViewKey = `lastView_${fsId}`;
  const lastView = localStorage.getItem(lastViewKey);
  const now = new Date().getTime();

  // Only track if:
  // 1. No previous view exists, or
  // 2. Last view was more than 24 hours ago
  if (!lastView || (now - parseInt(lastView)) > 24 * 60 * 60 * 1000) {
    // Update the last view timestamp
    localStorage.setItem(lastViewKey, now.toString());

    // Send the view to your backend
    fetch(`https://web-api-886292162262.europe-west1.run.app/api/items/${fsId}/views`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        fsId: fsId,
        shop: 'maiShop',
      })
    })
    .then(response => response.json())
    .catch(error => {
      console.error('Error tracking view:', error);
    });
  }
}

// Get product page fsId (SKU) from main product or recommendations block
function getProductPageFsId() {
  const mainProduct = document.querySelector('[data-product-sku]');
  if (mainProduct) return mainProduct.getAttribute('data-product-sku');
  const withSku = document.querySelector('[data-sku]');
  return withSku ? withSku.dataset.sku : null;
}

const THEME_VERSION = "1.7";

// Initialize view tracking when DOM is loaded
document.addEventListener(
  "DOMContentLoaded",
  function logDevelopmentVersion() {
    const versionEl = document.getElementById("account-version");
    const isAppMode = document.documentElement.classList.contains("app-mode");

    if (versionEl && isAppMode) {
      versionEl.textContent = `Version ${THEME_VERSION}`;
      versionEl.hidden = false;
    }

    console.log(`Version: ${THEME_VERSION}`); // Can be used to check if the latest development version is loaded
  },
  { once: true }
);

document.addEventListener("DOMContentLoaded", function () {
  // Use querySelectorAll to get all watch buttons (both mobile and desktop)
  const watchButtons = document.querySelectorAll("#watch-search-mobile, #watch-search-desktop");

  // Add event listeners to all instances
  watchButtons.forEach(button => {
    button.addEventListener("click", function () {
      showSaveWatchToast();
    });
  });

  const unwatchButtons = document.querySelectorAll("#unwatch-search-mobile, #unwatch-search-desktop");
  unwatchButtons.forEach(button => {
    button.addEventListener("click", function () {
      unwatchSearch();
    });
  });

  // Check if we're on a product page by looking for product ID / SKU (trackItemView only; product-view is in product-view-tracking.js)
  const fsId = getProductPageFsId();
  if (fsId) {
    try {
      trackItemView(fsId);
    } catch (error) {
      console.error('Error in trackItemView:', error);
    }
  }

  setTimeout(function () {
    document.querySelectorAll(".wk-button").forEach(function (icon) {
      icon.addEventListener("click", function () {
        if (!icon.classList.contains("wk-selected")) {
          showToast();
        }
      });
    });
  }, 1000);
});

document.addEventListener("DOMContentLoaded", function initAppSearchParamPreserver() {
  const appValue = new URLSearchParams(window.location.search).get("app");
  if (!appValue) return;

  const applyParamToForms = () => {
    document.querySelectorAll("form[data-app-search-form]").forEach((form) => {
      if (!form) return;
      let hiddenInput = form.querySelector('input[name="app"]');
      if (!hiddenInput) {
        hiddenInput = document.createElement("input");
        hiddenInput.type = "hidden";
        hiddenInput.name = "app";
        form.appendChild(hiddenInput);
      }
      hiddenInput.value = appValue;
    });
  };

  applyParamToForms();
  document.addEventListener("shopify:section:load", applyParamToForms);
  document.addEventListener("shopify:section:select", applyParamToForms);
});

function normalizeWatchUrl(urlString) {
  try {
    const url = new URL(urlString, window.location.origin);
    url.searchParams.delete('sort_by');
    url.searchParams.delete('page');
    url.searchParams.delete('app');
    url.searchParams.delete('preview_theme_id');
    const sortedParams = Array.from(url.searchParams.entries())
      .sort((a, b) => a[0].localeCompare(b[0]))
      .filter((item, index, self) =>
        index === self.findIndex((t) => t[0] === item[0] && t[1] === item[1])
      )
      .map(param => param.join('='))
      .join('&');
    return url.pathname + (sortedParams ? '?' + sortedParams : '');
  } catch (e) {
    return urlString;
  }
}

function isPageWatched() {
  let currentUrl = new URL(window.location.href);
  if (currentUrl.searchParams.get('watchId')) {
    return true;
  }

  // Retrieve the value from the cookie
  const cookieValue = checkCookie('watches');

  // Check if the cookie value is valid before parsing it
  if (cookieValue) {
    try {
      const watches = JSON.parse(cookieValue);

      if (watches && Array.isArray(watches)) {
        const currentNormalized = normalizeWatchUrl(window.location.href);
        return watches.some(watch => normalizeWatchUrl(watch.url) === currentNormalized);
      }
    } catch (error) {
      console.error("Invalid JSON in watches cookie:", error);
    }
  }

  return false;
}

function updateWatchButtonState() {
  const unwatchElement = document.getElementById("unwatch-search-mobile");
  const watchElement = document.getElementById("watch-search-mobile");

  if (unwatchElement && watchElement) {
    if (isPageWatched()) {
      unwatchElement.style.display = "flex";
      watchElement.style.display = "none";
    } else {
      unwatchElement.style.display = "none";
      watchElement.style.display = "flex";
    }
  }
}

function showToast() {
  // Don't show toast in app-mode
  if (document.documentElement.classList.contains('app-mode')) {
    return;
  }

  if (!checkCookie("toastShown")) {
    document.getElementById("toast-notification").style.display = "flex";
    setCookie("toastShown", "true", 1); // Set cookie for 1 day
  }
}

function showSaveWatchToast() {
  // Check for pagination and more than 10 pages
  const paginationItems = document.querySelectorAll('a.pagination__item.link');
  for (let item of paginationItems) {
    const pageNumber = parseInt(item.textContent.trim());
    if (!isNaN(pageNumber) && pageNumber > 10) {
      alert("Denna sökning visar för många plagg för att bevaka (fler än 10 sidor). Smalna av din filtrering och försök igen.");
      return;
    }
  }

  // If the user is logged in via Firebase, use their email directly (skip email input)
  const auth = window.firebaseAuth;
  if (auth && typeof auth.waitForAuthState === 'function') {
    auth.waitForAuthState(2000).then(function (user) {
      if (user && user.email) {
        const toastEl = document.getElementById("toast-save-watch");
        if (toastEl) toastEl.setAttribute("data-customer-email", user.email);
        saveWatch();
      } else {
        document.getElementById("toast-save-watch").style.display = "flex";
      }
    }).catch(function () {
      document.getElementById("toast-save-watch").style.display = "flex";
    });
    return;
  }

  document.getElementById("toast-save-watch").style.display = "flex";
}

async function showConfirmationToast(text) {
  const toast = document.getElementById('confirmation-toast');
  document.getElementById('confirmation-text').textContent = text;
  toast.style.display = 'flex';
  setTimeout(() => {
    toast.classList.add('show');
  }, 10);

  await new Promise(resolve => {
    setTimeout(() => {
      toast.classList.remove('show');
      setTimeout(() => {
        toast.style.display = 'none';
      }, 300);
      resolve();
    }, 3000);
  });
}

function getUrlForWatch() {
  const url = new URL(window.location.href);
  url.searchParams.delete('sort_by');
  url.searchParams.delete('page');

  // Create a sorted string of unique query parameters
  const sortedParams = Array.from(url.searchParams.entries())
    .sort((a, b) => a[0].localeCompare(b[0]))
    .filter((item, index, self) =>
      index === self.findIndex((t) => t[0] === item[0] && t[1] === item[1])
    )
    .map(param => param.join('='))
    .join('&');

  return `${url.origin}${url.pathname}?${sortedParams}`;
}

async function unwatchSearch() {
  const urlParams = new URLSearchParams(window.location.search);
  let watchIdUrl = urlParams.get('watchId');
  const cookieValue = checkCookie('watches');
  const watches = cookieValue ? JSON.parse(cookieValue) : null;
  console.log("watches: ", watches);
  let watchIdSource = 'url';
  let watchIdCookie = null;
  if (!watchIdUrl && watches.length) {
    const currentNormalized = normalizeWatchUrl(window.location.href);
    watchIdCookie = watches.find(watch => normalizeWatchUrl(watch.url) === currentNormalized)?.fsId;
    watchIdSource = 'cookie';
  }
  console.log("watchIdUrl: ", watchIdUrl);
  console.log("watchIdCookie: ", watchIdCookie);
  const watchId = watchIdUrl || watchIdCookie;
  if (watchId) {
    await fetch(`${window.API_BASE_URL}/watch/${watchId}`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
      },
    });
    await showConfirmationToast(window.watchStrings?.watchRemoved || 'Bevakningen togs bort');
    if (watchIdCookie) {
      const updatedWatches = watches.filter(watch => watch.fsId !== watchId);
      setCookie('watches', JSON.stringify(updatedWatches), 1);
    }
    if (watchIdUrl) {
      const url = new URL(window.location.href);
      url.searchParams.delete('watchId');
      window.location.href = url.toString();
    } else {
      ["mobile", "desktop"].forEach(placement => {
        document.getElementById(`watch-search-${placement}`).style.display = "flex";
        document.getElementById(`unwatch-search-${placement}`).style.display = "none";
      });
    }
  } else {
    console.error('Watch ID not found');
  }
}
setInterval(updateWatchButtonState, 2000);

// Initial check
updateWatchButtonState();

/*END - Custom code*/

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute("role", "button");
  summary.setAttribute(
    "aria-expanded",
    summary.parentNode.hasAttribute("open")
  );

  if (summary.nextElementSibling.getAttribute("id")) {
    summary.setAttribute("aria-controls", summary.nextElementSibling.id);
  }

  summary.addEventListener("click", (event) => {
    event.currentTarget.setAttribute(
      "aria-expanded",
      !event.currentTarget.closest("details").hasAttribute("open")
    );
  });

  if (summary.closest("header-drawer")) return;
  summary.parentElement.addEventListener("keyup", onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);

  elementToFocus.focus();
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(":focus-visible");
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    "ARROWUP",
    "ARROWDOWN",
    "ARROWLEFT",
    "ARROWRIGHT",
    "TAB",
    "ENTER",
    "SPACE",
    "ESCAPE",
    "HOME",
    "END",
    "PAGEUP",
    "PAGEDOWN",
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener("keydown", (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener("mousedown", (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    "focus",
    () => {
      if (currentFocusedElement)
        currentFocusedElement.classList.remove("focused");

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add("focused");
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll(".js-youtube").forEach((video) => {
    video.contentWindow.postMessage(
      '{"event":"command","func":"' + "pauseVideo" + '","args":""}',
      "*"
    );
  });
  document.querySelectorAll(".js-vimeo").forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', "*");
  });
  document.querySelectorAll("video").forEach((video) => video.pause());
  document.querySelectorAll("product-model").forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus({ preventScroll: true });
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== "ESCAPE") return;

  const openDetailsElement = event.target.closest("details[open]");
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector("summary");
  openDetailsElement.removeAttribute("open");
  summaryElement.setAttribute("aria-expanded", false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.changeEvent = new Event("change", { bubbles: true });

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);
  }
}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector("details");

    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );

    this.addEventListener("keyup", this.onKeyUp.bind(this));
    this.addEventListener("focusout", this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll("summary").forEach((summary) =>
      summary.addEventListener("click", this.onSummaryClick.bind(this))
    );
    this.querySelectorAll("button:not(.menu-drawer__tab)").forEach((button) =>
      button.addEventListener("click", this.onCloseButtonClick.bind(this))
    );

    const facetsOverlay = this.querySelector(".mobile-facets");
    if (facetsOverlay) {
      facetsOverlay.addEventListener("click", (event) => {
        if (event.target !== facetsOverlay) return;
        event.preventDefault();
        this.closeMenuDrawer(
          event,
          this.mainDetailsToggle.querySelector("summary")
        );
      });
    }
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== "ESCAPE") return;

    const openDetailsElement = event.target.closest("details[open]");
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(
        event,
        this.mainDetailsToggle.querySelector("summary")
      )
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest(".has-submenu");
    const isOpen = detailsElement.hasAttribute("open");
    const reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)");

    function addTrapFocus() {
      trapFocus(
        summaryElement.nextElementSibling,
        detailsElement.querySelector("button")
      );
      summaryElement.nextElementSibling.removeEventListener(
        "transitionend",
        addTrapFocus
      );
    }

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen
        ? this.closeMenuDrawer(event, summaryElement)
        : this.openMenuDrawer(summaryElement);
    } else {
      setTimeout(() => {
        detailsElement.classList.add("menu-opening");
        summaryElement.setAttribute("aria-expanded", true);
        parentMenuElement && parentMenuElement.classList.add("submenu-open");
        !reducedMotion || reducedMotion.matches
          ? addTrapFocus()
          : summaryElement.nextElementSibling.addEventListener(
            "transitionend",
            addTrapFocus
          );
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    this.mainDetailsToggle.classList.remove("menu-closing");
    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });
    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.add("menu-closing");
    this.mainDetailsToggle.classList.remove("menu-opening");
    this.mainDetailsToggle.querySelectorAll("details").forEach((details) => {
      details.removeAttribute("open");
      details.classList.remove("menu-opening");
    });
    this.mainDetailsToggle
      .querySelectorAll(".submenu-open")
      .forEach((submenu) => {
        submenu.classList.remove("submenu-open");
      });
    document.body.classList.remove(
      `overflow-hidden-${this.dataset.breakpoint}`
    );
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);
  }

  onFocusOut(event) {
    setTimeout(() => {
      if (
        this.mainDetailsToggle.hasAttribute("open") &&
        !this.mainDetailsToggle.contains(document.activeElement)
      )
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest("details");
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest(".submenu-open");
    parentMenuElement && parentMenuElement.classList.remove("submenu-open");
    detailsElement.classList.remove("menu-opening");
    detailsElement
      .querySelector("summary")
      .setAttribute("aria-expanded", false);
    removeTrapFocus(detailsElement.querySelector("summary"));
    this.closeAnimation(detailsElement);
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute("open");
        detailsElement.classList.remove("menu-closing");
        if (detailsElement.closest("details[open]")) {
          trapFocus(
            detailsElement.closest("details[open]"),
            detailsElement.querySelector("summary")
          );
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define("menu-drawer", MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header =
      this.header || document.getElementById("shopify-section-header");
    this.borderOffset =
      this.borderOffset ||
        this.closest(".header-wrapper").classList.contains(
          "header-wrapper--border-bottom"
        )
        ? 1
        : 0;
    document.documentElement.style.setProperty(
      "--header-bottom-position",
      `${parseInt(
        this.header.getBoundingClientRect().bottom - this.borderOffset
      )}px`
    );
    this.header.classList.add("menu-open");

    setTimeout(() => {
      this.mainDetailsToggle.classList.add("menu-opening");
    });

    summaryElement.setAttribute("aria-expanded", true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove("menu-open", "shopify-section-header-hidden");
  }
}

customElements.define("header-drawer", HeaderDrawer);

// Menu drawer tabs functionality
function initMenuDrawerTabs() {
  const tabContainers = document.querySelectorAll('[data-menu-drawer-tabs]');

  tabContainers.forEach((container) => {
    // Skip if already initialized
    if (container.dataset.tabsInitialized === 'true') return;

    const tabs = container.querySelectorAll('.menu-drawer__tab');
    const navigation = container.closest('.menu-drawer__navigation');
    const panels = navigation ? navigation.querySelectorAll('.menu-drawer__tabpanel') : [];

    if (tabs.length === 0 || panels.length === 0) return;

    // Mark as initialized
    container.dataset.tabsInitialized = 'true';

    // Restore saved tab from localStorage
    const savedTabIndex = localStorage.getItem('menu-drawer-active-tab');
    let activeTabIndex = savedTabIndex !== null ? parseInt(savedTabIndex, 10) : 0;

    // Validate saved index
    if (activeTabIndex < 0 || activeTabIndex >= tabs.length) {
      activeTabIndex = 0;
    }

    // Set initial active tab
    tabs.forEach((tab, index) => {
      const isActive = index === activeTabIndex;
      tab.classList.toggle('menu-drawer__tab--active', isActive);
      tab.setAttribute('aria-selected', isActive);
    });

    panels.forEach((panel, index) => {
      const isActive = index === activeTabIndex;
      panel.classList.toggle('menu-drawer__tabpanel--active', isActive);
      if (isActive) {
        panel.removeAttribute('hidden');
      } else {
        panel.setAttribute('hidden', '');
      }
    });

    // Tab click handler - use capture phase to run before other handlers
    tabs.forEach((tab, index) => {
      const handleTabClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();

        // Update tabs
        tabs.forEach((t, i) => {
          const isActive = i === index;
          t.classList.toggle('menu-drawer__tab--active', isActive);
          t.setAttribute('aria-selected', isActive);
        });

        // Update panels
        panels.forEach((panel, i) => {
          const isActive = i === index;
          panel.classList.toggle('menu-drawer__tabpanel--active', isActive);
          if (isActive) {
            panel.removeAttribute('hidden');
          } else {
            panel.setAttribute('hidden', '');
          }
        });

        // Save to localStorage
        localStorage.setItem('menu-drawer-active-tab', index.toString());
      };

      // Use capture phase to ensure our handler runs first
      tab.addEventListener('click', handleTabClick, true);
    });
  });
}

// Initialize tabs when drawer opens
document.addEventListener('DOMContentLoaded', () => {
  initMenuDrawerTabs();

  // Also initialize when drawer details open/close
  const drawerDetails = document.querySelectorAll('header-drawer details, menu-drawer details');
  drawerDetails.forEach((details) => {
    details.addEventListener('toggle', () => {
      if (details.hasAttribute('open')) {
        // Reset initialization flags when drawer opens to allow re-initialization
        const tabContainers = details.querySelectorAll('[data-menu-drawer-tabs]');
        tabContainers.forEach((container) => {
          container.removeAttribute('data-tabs-initialized');
        });
        // Small delay to ensure DOM is ready
        setTimeout(() => {
          initMenuDrawerTabs();
        }, 100);
      }
    });
  });
});

function hasNavigatedFromHistory(event) {
  if (event && event.persisted) return true;

  if (
    window.performance &&
    typeof window.performance.getEntriesByType === "function"
  ) {
    const navigationEntries = window.performance.getEntriesByType("navigation");

    if (navigationEntries.some((entry) => entry.type === "back_forward")) {
      return true;
    }
  }

  if (
    window.performance &&
    window.performance.navigation &&
    window.performance.navigation.type ===
      window.performance.navigation.TYPE_BACK_FORWARD
  ) {
    return true;
  }

  return false;
}

function closeOpenMenuDrawersOnHistoryNavigation() {
  document.querySelectorAll("menu-drawer, header-drawer").forEach((drawer) => {
    const detailsToggle =
      drawer.mainDetailsToggle || drawer.querySelector("details");

    if (
      !detailsToggle ||
      !detailsToggle.hasAttribute("open") ||
      typeof drawer.closeMenuDrawer !== "function"
    ) {
      return;
    }

    drawer.closeMenuDrawer(new Event("navigation:history"), false);
  });
}

// Close any stale menu drawers restored from bfcache/back navigation.
window.addEventListener("pageshow", (event) => {
  if (!hasNavigatedFromHistory(event)) return;
  closeOpenMenuDrawersOnHistoryNavigation();
});

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      "click",
      this.hide.bind(this, false)
    );
    this.addEventListener("keyup", (event) => {
      if (event.code.toUpperCase() === "ESCAPE") this.hide();
    });
    if (this.classList.contains("media-modal")) {
      this.addEventListener("pointerup", (event) => {
        if (
          event.pointerType === "mouse" &&
          !event.target.closest("deferred-media, product-model")
        )
          this.hide();
      });
    } else {
      this.addEventListener("click", (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector(".template-popup");
    document.body.classList.add("overflow-hidden");
    this.setAttribute("open", "");
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove("overflow-hidden");
    document.body.dispatchEvent(new CustomEvent("modalClosed"));
    this.removeAttribute("open");
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define("modal-dialog", ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector("button");

    if (!button) return;
    button.addEventListener("click", () => {
      const modal = document.querySelector(this.getAttribute("data-modal"));
      if (modal) modal.show(button);
    });
  }
}
customElements.define("modal-opener", ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener("click", this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute("loaded")) {
      const content = document.createElement("div");
      content.appendChild(
        this.querySelector("template").content.firstElementChild.cloneNode(true)
      );

      this.setAttribute("loaded", true);
      const deferredElement = this.appendChild(
        content.querySelector("video, model-viewer, iframe")
      );
      if (focus) deferredElement.focus();
    }
  }
}

customElements.define("deferred-media", DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector(".slider-counter--current");
    this.pageTotalElement = this.querySelector(".slider-counter--total");
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener("scroll", this.update.bind(this));
    this.prevButton.addEventListener("click", this.onButtonClick.bind(this));
    this.nextButton.addEventListener("click", this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter(
      (element) => element.clientWidth > 0
    );
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset =
      this.sliderItemsToShow[1].offsetLeft -
      this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) /
      this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    if (!this.sliderItemsToShow || !this.sliderItemsToShow.length) return;
    const previousPage = this.currentPage;
    this.currentPage =
      Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent("slideChanged", {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (
      this.isSlideVisible(this.sliderItemsToShow[0]) &&
      this.slider.scrollLeft === 0
    ) {
      this.prevButton.setAttribute("disabled", "disabled");
    } else {
      this.prevButton.removeAttribute("disabled");
    }

    if (
      this.isSlideVisible(
        this.sliderItemsToShow[this.sliderItemsToShow.length - 1]
      )
    ) {
      this.nextButton.setAttribute("disabled", "disabled");
    } else {
      this.nextButton.removeAttribute("disabled");
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide =
      this.slider.clientWidth + this.slider.scrollLeft - offset;
    return (
      element.offsetLeft + element.clientWidth <= lastVisibleSlide &&
      element.offsetLeft >= this.slider.scrollLeft
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === "next"
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }
}

customElements.define("slider-component", SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector(".slider-buttons");
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector(".slideshow__slide");
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.sliderControlLinksArray = Array.from(
      this.sliderControlWrapper.querySelectorAll(".slider-counter__link")
    );
    this.sliderControlLinksArray.forEach((link) =>
      link.addEventListener("click", this.linkToSlide.bind(this))
    );
    this.slider.addEventListener("scroll", this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.slider.getAttribute("data-autoplay") === "true")
      this.setAutoPlay();
  }

  setAutoPlay() {
    this.sliderAutoplayButton = this.querySelector(".slideshow__autoplay");
    this.autoplaySpeed = this.slider.dataset.speed * 1000;

    this.sliderAutoplayButton.addEventListener(
      "click",
      this.autoPlayToggle.bind(this)
    );
    this.addEventListener("mouseover", this.focusInHandling.bind(this));
    this.addEventListener("mouseleave", this.focusOutHandling.bind(this));
    this.addEventListener("focusin", this.focusInHandling.bind(this));
    this.addEventListener("focusout", this.focusOutHandling.bind(this));

    this.play();
    this.autoplayButtonIsSetToPlay = true;
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) return;

    if (isFirstSlide && event.currentTarget.name === "previous") {
      this.slideScrollPosition =
        this.slider.scrollLeft +
        this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === "next") {
      this.slideScrollPosition = 0;
    }
    this.slider.scrollTo({
      left: this.slideScrollPosition,
    });
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll(".slider-counter__link");
    this.prevButton.removeAttribute("disabled");

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove("slider-counter__link--active");
      link.removeAttribute("aria-current");
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add(
      "slider-counter__link--active"
    );
    this.sliderControlButtons[this.currentPage - 1].setAttribute(
      "aria-current",
      true
    );
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
    this.play();
  }

  focusInHandling(event) {
    const focusedOnAutoplayButton =
      event.target === this.sliderAutoplayButton ||
      this.sliderAutoplayButton.contains(event.target);
    if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
      this.play();
    } else if (this.autoplayButtonIsSetToPlay) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute("aria-live", "off");
    clearInterval(this.autoplay);
    this.autoplay = setInterval(
      this.autoRotateSlides.bind(this),
      this.autoplaySpeed
    );
  }

  pause() {
    this.slider.setAttribute("aria-live", "polite");
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.playSlideshow
      );
    } else {
      this.sliderAutoplayButton.classList.remove("slideshow__autoplay--paused");
      this.sliderAutoplayButton.setAttribute(
        "aria-label",
        window.accessibilityStrings.pauseSlideshow
      );
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length
        ? 0
        : this.slider.scrollLeft +
        this.slider.querySelector(".slideshow__slide").clientWidth;
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }

  setSlideVisibility() {
    this.sliderItemsToShow.forEach((item, index) => {
      const button = item.querySelector("a");
      if (index === this.currentPage - 1) {
        if (button) button.removeAttribute("tabindex");
        item.setAttribute("aria-hidden", "false");
        item.removeAttribute("tabindex");
      } else {
        if (button) button.setAttribute("tabindex", "-1");
        item.setAttribute("aria-hidden", "true");
        item.setAttribute("tabindex", "-1");
      }
    });
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
      (this.sliderControlLinksArray.indexOf(event.currentTarget) +
        1 -
        this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define("slideshow-component", SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener("change", this.onVariantChange);
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton(true, "", false);
    this.updatePickupAvailability();
    this.removeErrorMessage();

    if (!this.currentVariant) {
      this.toggleAddButton(true, "", true);
      this.setUnavailable();
    } else {
      this.updateMedia();
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select"),
      (select) => select.value
    );
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(
      `MediaGallery-${this.dataset.section}`
    );
    mediaGallery.setActiveMedia(
      `${this.dataset.section}-${this.currentVariant.featured_media.id}`,
      true
    );

    const modalContent = document.querySelector(
      `#ProductModal-${this.dataset.section} .product-media-modal__content`
    );
    if (!modalContent) return;
    const newMediaModal = modalContent.querySelector(
      `[data-media-id="${this.currentVariant.featured_media.id}"]`
    );
    modalContent.prepend(newMediaModal);
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === "false") return;
    window.history.replaceState(
      {},
      "",
      `${this.dataset.url}?variant=${this.currentVariant.id}`
    );
  }

  updateShareUrl() {
    const shareButton = document.getElementById(
      `Share-${this.dataset.section}`
    );
    const galleryShareButton = document.getElementById(
      `Share-gallery-${this.dataset.section}`
    );
    const shareDomain = window.shopUrl ? window.shopUrl.replace('mairesale.com', 'share.mairesale.com') : window.location.origin.replace('mairesale.com', 'share.mairesale.com');
    const shareUrl = `${shareDomain}${this.dataset.url}?variant=${this.currentVariant.id}`;

    if (shareButton && shareButton.updateUrl) {
      shareButton.updateUrl(shareUrl);
    }
    if (galleryShareButton && galleryShareButton.updateUrl) {
      galleryShareButton.updateUrl(shareUrl);
    }
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section}, #product-form-installment-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  removeErrorMessage() {
    const section = this.closest("section");
    if (!section) return;

    const productForm = section.querySelector("product-form");
    if (productForm) productForm.handleErrorMessage();
  }

  renderProductInfo() {
    fetch(
      `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.originalSection
        ? this.dataset.originalSection
        : this.dataset.section
      }`
    )
      .then((response) => response.text())
      .then((responseText) => {
        const html = new DOMParser().parseFromString(responseText, "text/html");
        const destination = document.getElementById(
          `price-${this.dataset.section}`
        );
        const source = html.getElementById(
          `price-${this.dataset.originalSection
            ? this.dataset.originalSection
            : this.dataset.section
          }`
        );
        if (source && destination) destination.innerHTML = source.innerHTML;

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove("visibility-hidden");
        this.toggleAddButton(
          !this.currentVariant.available,
          window.variantStrings.soldOut
        );
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    if (!productForm) return;
    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    if (!addButton) return;

    if (disable) {
      addButton.setAttribute("disabled", "disabled");
      if (text) addButtonText.textContent = text;
    } else {
      addButton.removeAttribute("disabled");
      addButtonText.textContent = window.variantStrings.addToCart;
    }

    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(
      `product-form-${this.dataset.section}`
    );
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    if (!addButton) return;
    addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add("visibility-hidden");
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define("variant-selects", VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
    super();
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }
}

customElements.define("variant-radios", VariantRadios);

class CartSyncStorage {
  static save(payload = {}) {
    if (!CartSyncStorage.isStorageAvailable()) return;

    const existing = CartSyncStorage.load() || { sections: {} };
    const mergedSections = {
      ...existing.sections,
      ...(payload.sections || {}),
    };
    const nextItemCount =
      typeof payload.item_count === "number"
        ? payload.item_count
        : existing.item_count;

    const hasSections = Object.keys(mergedSections).length > 0;
    const hasItemCount = typeof nextItemCount === "number";

    if (!hasSections && !hasItemCount) return;

    const data = {
      sections: mergedSections,
      item_count: nextItemCount,
      updated_at: Date.now(),
    };

    try {
      sessionStorage.setItem(
        CartSyncStorage.STORAGE_KEY,
        JSON.stringify(data)
      );
    } catch (error) {
      console.warn("Cart sync cache unavailable", error);
    }
  }

  static load() {
    if (!CartSyncStorage.isStorageAvailable()) return null;
    try {
      const raw = sessionStorage.getItem(CartSyncStorage.STORAGE_KEY);
      return raw ? JSON.parse(raw) : null;
    } catch (error) {
      console.warn("Cart sync cache read failed", error);
      return null;
    }
  }

  static isStorageAvailable() {
    if (typeof CartSyncStorage.storageAvailable === "boolean") {
      return CartSyncStorage.storageAvailable;
    }
    try {
      if (typeof window === "undefined" || !window.sessionStorage) {
        CartSyncStorage.storageAvailable = false;
        return false;
      }
      const testKey = "__cartSyncTest";
      sessionStorage.setItem(testKey, "1");
      sessionStorage.removeItem(testKey);
      CartSyncStorage.storageAvailable = true;
    } catch (_error) {
      CartSyncStorage.storageAvailable = false;
    }
    return CartSyncStorage.storageAvailable;
  }
}

CartSyncStorage.STORAGE_KEY = "cartSyncCache";
CartSyncStorage.storageAvailable = undefined;
window.CartSyncStorage = CartSyncStorage;

class CartStateSynchronizer {
  constructor() {
    this.onPageShow = this.onPageShow.bind(this);
    window.addEventListener("pageshow", this.onPageShow);
  }

  onPageShow(event) {
    if (!CartStateSynchronizer.shouldResync(event)) return;
    this.applyCachedState();
    this.refreshCartBubble();
    this.refreshCartPage();
  }

  applyCachedState() {
    const cachedData = CartStateSynchronizer.getCachedState();
    if (!cachedData) return;

    this.renderCartBubbleFromCache(cachedData);
    this.renderCartPageFromCache(cachedData);
  }

  refreshCartBubble() {
    const targets = CartStateSynchronizer.getCartBubbleTargets();
    if (!targets.length) return;

    CartStateSynchronizer.fetchSectionHTML("cart-icon-bubble")
      .then((html) => {
        if (!html) return;
        CartStateSynchronizer.renderCartBubbleHTML(html);
        const itemCount = CartStateSynchronizer.deriveItemCountFromSection(html);
        CartStateSynchronizer.persistSections(
          { "cart-icon-bubble": html },
          itemCount
        );
      })
      .catch((error) => {
        console.error("Failed to refresh cart bubble", error);
      });
  }

  refreshCartPage() {
    const cartItemsElement = document.querySelector("cart-items");
    if (!cartItemsElement || typeof cartItemsElement.refreshFromServer !== "function") return;

    cartItemsElement.refreshFromServer();
  }

  static shouldResync(event) {
    if (event && event.persisted) return true;

    const navigationEntries =
      typeof performance !== "undefined" &&
      performance.getEntriesByType
        ? performance.getEntriesByType("navigation")
        : [];
    if (navigationEntries.length && navigationEntries[0].type === "back_forward") {
      return true;
    }

    if (
      typeof performance !== "undefined" &&
      performance.navigation &&
      performance.navigation.type === 2
    ) {
      return true;
    }

    return false;
  }

  static getCartBubbleTargets() {
    return ["cart-icon-bubble", "cart-icon-bubble-top"]
      .map((id) => document.getElementById(id))
      .filter((element) => element);
  }

  renderCartBubbleFromCache(cachedData) {
    if (!cachedData.sections) return;
    const html = cachedData.sections["cart-icon-bubble"];
    if (!html) return;
    CartStateSynchronizer.renderCartBubbleHTML(html);
  }

  renderCartPageFromCache(cachedData) {
    const cartItemsElement = document.querySelector("cart-items");
    if (!cartItemsElement || typeof cartItemsElement.hydrateFromCache !== "function") return;
    cartItemsElement.hydrateFromCache(cachedData);
  }

  static renderCartBubbleHTML(html) {
    const targets = CartStateSynchronizer.getCartBubbleTargets();
    if (!targets.length || !html) return;

    targets.forEach((target) => {
      CartStateSynchronizer.replaceSectionInnerHTML(
        target,
        html,
        ".shopify-section"
      );
    });
  }

  static fetchSectionHTML(sectionId) {
    const url = CartStateSynchronizer.buildSectionFetchUrl(sectionId);
    return fetch(url, { cache: "no-store", headers: { "Cache-Control": "no-cache" } })
      .then((response) => {
        if (!response.ok) throw new Error(`Failed to fetch section ${sectionId}`);
        return response.text();
      })
      .catch((error) => {
        console.error(error);
        return null;
      });
  }

  static replaceSectionInnerHTML(target, sectionHtml, selector) {
    if (!sectionHtml) return;
    const parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
    const replacement = parsed.querySelector(selector);
    if (!replacement) return;
    target.innerHTML = replacement.innerHTML;
  }

  static buildSectionFetchUrl(sectionId) {
    try {
      const url = new URL(window.location.href);
      url.searchParams.set("section_id", sectionId);
      return url.toString();
    } catch (_error) {
      return `${window.location.pathname}?section_id=${sectionId}`;
    }
  }
  static getCachedState() {
    if (!window.CartSyncStorage || typeof window.CartSyncStorage.load !== "function") return null;
    return window.CartSyncStorage.load();
  }

  static persistSections(sections, itemCount) {
    if (!window.CartSyncStorage || !sections) return;
    window.CartSyncStorage.save({
      sections,
      item_count: typeof itemCount === "number" ? itemCount : undefined,
    });
  }

  static deriveItemCountFromSection(sectionHtml) {
    if (!sectionHtml) return undefined;
    try {
      const parsed = new DOMParser().parseFromString(sectionHtml, "text/html");
      const bubble = parsed.querySelector(
        ".cart-count-bubble span[aria-hidden='true']"
      );
      if (bubble && bubble.textContent) {
        const parsedCount = parseInt(bubble.textContent.trim(), 10);
        return Number.isNaN(parsedCount) ? undefined : parsedCount;
      }
      const bubbleContainer = parsed.querySelector(".cart-count-bubble");
      if (!bubbleContainer) return 0;
    } catch (_error) {
      return undefined;
    }
    return undefined;
  }
}

window.cartStateSynchronizer = new CartStateSynchronizer();

/**
 * Updates the header account icon to "logged in" state (href to /account, label "Account",
 * remove menu-drawer__account and preventDefault) without reload. Call after session-cookie
 * bootstrap or any login that sets window.customerLoggedIn without navigating.
 */
window.maiUpdateAccountHeaderOnLogin = function () {
  if (window.customerLoggedIn !== true) return;

  const accountUrl =
    document.querySelector("[data-account-url]")?.getAttribute("data-account-url") || "/account";
  const labelLoggedIn =
    document.querySelector("[data-label-logged-in]")?.getAttribute("data-label-logged-in") || "Account";

  // Header icon (desktop / visible on larger screens)
  document.querySelectorAll(".header__icon--account").forEach((link) => {
    link.setAttribute("href", accountUrl);
    link.removeAttribute("onclick");
    link.classList.remove("menu-drawer__account");
    link.setAttribute("aria-label", labelLoggedIn);
    const hidden = link.querySelector(".visually-hidden");
    if (hidden) hidden.textContent = labelLoggedIn;
  });

  // Menu drawer account link (mobile) — exclude .header__icon--account which is the desktop icon
  document.querySelectorAll(".menu-drawer__account:not(.header__icon--account)").forEach((link) => {
    link.setAttribute("href", accountUrl);
    link.setAttribute("aria-label", labelLoggedIn);
    const icon = link.querySelector(".icon.icon-account");
    link.textContent = "";
    if (icon) link.appendChild(icon);
    link.appendChild(document.createTextNode(" " + labelLoggedIn));
  });
};

function maiOnLoginSuccess() {
  if (window.customerLoggedIn) {
    if (typeof window.maiUpdateAccountHeaderOnLogin === "function") {
      window.maiUpdateAccountHeaderOnLogin();
    }
  }
  if (window.cartStateSynchronizer && typeof window.cartStateSynchronizer.refreshCartBubble === "function") {
    window.cartStateSynchronizer.refreshCartBubble();
  }
}

document.addEventListener("mai:auth:login-success", maiOnLoginSuccess);

document.addEventListener("DOMContentLoaded", function () {
  if (window.customerLoggedIn === true) {
    maiOnLoginSuccess();
  }
});

